import { computed } from "vue";

import { EstimateItem } from "../../entities/estimate";
import { Partition } from "../../entities/partition";
import { CreateOneStrategy } from "../base/creation.strategy";

import { useNewEstimateStore } from "@/stores/new/estimateStore";
import { useEstimateReviewStore } from '@/stores/new/estimateReview.store';
import { Pricing } from "@/app/domain";

export class EstimateItemCreationStrategy extends CreateOneStrategy {
    constructor(
        partition: Partition,
    ) {
        const estimateStore = useNewEstimateStore();
        const estimateReviewStore = useEstimateReviewStore();
        const dealType = computed(() => estimateStore.estimate.dealTypeCode);

        const servicesSum = estimateReviewStore.calculateServiceSum();
        const servicesSumPrice = servicesSum.getSystemPrice(dealType.value).getValue();
        const overheadSum = estimateReviewStore.calculateOverheadSum();
        const overheadSumPrice = overheadSum.getSystemPrice(dealType.value).getValue();

        const partitionMaterialPrice = partition.sum.getSystemPrice(dealType.value).getValue();
        const materialPriceTotal = computed(() => estimateReviewStore.materialPriceSum);
        const percentOfTotal = ((partitionMaterialPrice / materialPriceTotal.value?.getSystemPrice(dealType.value).getValue()) * 100).toFixed(1);

        const partitionArea = parseFloat(partition.dimensions.getAreaFt().toSquareFt().formatSq()) * parseFloat(partition.qty)
        const overheadPart = ((+percentOfTotal * overheadSumPrice) / 100).toFixed(2);
        const servicesPart = ((+percentOfTotal * servicesSumPrice) / 100).toFixed(2);

        const overheadPrice = +overheadPart || 0;
        const servicePrice = +servicesPart || 0;
        const partitionTotal = partitionMaterialPrice + overheadPrice + servicePrice;
        partition.partitionPrice = +partitionTotal.toFixed(2) || 0;

        const estimateItemConfig = {
            title: partition.title || 'Opening',
            width: partition.dimensions.width.ft || 0,
            height: partition.dimensions.height.ft || 0,
            parentId: partition.code,
            overheadPrice: new Pricing(overheadPrice, overheadPrice, overheadPrice),
            servicePrice: new Pricing(servicePrice, servicePrice, servicePrice),
            qty: partitionArea || 0,
            price: partition.sum, //material price
            sum: new Pricing(partitionTotal, partitionTotal, partitionTotal), // partition total
        };

        super(estimateItemConfig, EstimateItem);
    }
}
